module.exports = __webpack_public_path__ + "static/media/ImgNovedades220906_3.96c72847.jpg";